export const  isValidValue = (value) =>{
    if (value !== null && value !== undefined) {
        if (typeof value === 'string' && value.trim() !== '') {
            return true;
        }
        return true;
    }
    return false;
}